import { XPath } from '../../controls/xpath';
import { Checkbox } from '../../controls/checkbox';
import { JsonPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { Password, PasswordComponentValue } from '../../controls/password';
import { Selectbox } from '../../controls/selectbox';
import { Layouts } from '../../controls/layouts';
import { Buttons } from '../../controls/buttons';
import { Datetimebox } from '../../controls/datetimebox';
import { Textbox } from '../../controls/textbox';

@Component({
  selector: 'app-control-test-two-way-binding',
  standalone: true,
  templateUrl: './control-test-two-way-binding.component.html',
  styleUrl: './control-test-two-way-binding.component.scss',
  imports: [JsonPipe, Layouts, Buttons, Datetimebox, Textbox, XPath, Selectbox, Checkbox, Password],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlTestTwoWayBindingComponent {
  // Keep the same secret identifier when resetting the demo data.
  private readonly passwordSecretId = '001c1d1fa3624f30b4491b4315cfa383';

  readonly myData: {
    name: string | null;
    email: string | null;
    zip: string | null;
    city: string | null;
    allowShowPassword: boolean | null;
    passwordHash: string | null;
    passwordSecret: PasswordComponentValue;
    xpath: string | null;
    backgroundColor: string | null;
    foregroundColor: string | null;
    moreColors: string[] | null;
    otherColors: string[] | null;
    receiveNewsletter: boolean | null;
    datetime: Date | null;
    date: Date | null;
    time: Date | null;
    whatever: string | null;
  } = {
      name: null,
      email: null,
      zip: null,
      city: null,
      allowShowPassword: null,
      passwordHash: null,
      passwordSecret: { id: this.passwordSecretId, value: null },
      xpath: null,
      backgroundColor: null,
      foregroundColor: null,
      moreColors: null,
      otherColors: null,
      receiveNewsletter: null,
      datetime: null,
      date: null,
      time: null,
      whatever: null,
    };

  readonly colors = signal<Array<{ id: string; name: string; }> | null>(null);

  refresh(): void {
    this.colors.set([
      { id: 'ba', name: 'Black' },
      { id: 'bu', name: 'Blue' },
      { id: 'ge', name: 'Green' },
      { id: 'cy', name: 'Cyan' },
      { id: 're', name: 'Red' },
      { id: 'ma', name: 'Magenta' },
      { id: 'yl', name: 'Yellow' },
      { id: 'wi', name: 'White' },
    ]);

    this.myData.name = 'John Doe';
    this.myData.email = 'john@example.com';
    this.myData.zip = '7100';
    this.myData.city = null;
    this.myData.allowShowPassword = false;
    this.myData.passwordHash = null;
    this.myData.passwordSecret = { id: this.passwordSecretId, value: null };
    this.myData.xpath = "/*[local-name()='custom-test-xml']/*[local-name()='whatever-id']";
    this.myData.backgroundColor = null;
    this.myData.foregroundColor = 'red';
    this.myData.moreColors = null;
    this.myData.otherColors = ['bu', 'ge', 're'];
    this.myData.receiveNewsletter = true;
    this.myData.datetime = new Date('2024-05-02T09:42:37Z');
    this.myData.date = new Date(1714600800000); // 2024-05-02T00:00:00+02:00
    this.myData.time = new Date(new Date().setHours(11, 37, 42)); // Today at 11:37:42 local time
    this.myData.whatever = '<init>';
  }
}
